import { useEffect } from "react";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import AuthLayout from "layouts/Auth/Auth.js";
import AdminLayout from "layouts/Admin/Admin.js";
import PrivacyPolicy from "pages/PrivacyPolicy/PrivacyPolicy";
import { DEFAULT_ROUTES } from "components/Common/constants";
import routes from "routes";
import { ForgetPassword } from "pages/ForgetPassword/ForgetPassword";
import { ResetPassword } from "pages/ForgetPassword/ResetPassword";
import NotFound404 from "components/Common/NotFound404";
import { ROLES } from "components/Common/constants";
import QuotationReview from "pages/Payment/QuotationReview";
import PaymentConfirmScreen from "pages/Payment/ConfirmPaymentScreen";
import PaymentStatus from "pages/Payment/PaymentStatus";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const local = localStorage.getItem("p");
  const token = JSON.parse(local)?.token;
  const role = JSON.parse(local)?.role;

  //use for defualt redirect after login
  const matchedKey = Object.keys(ROLES).find((key) => ROLES[key] === role);
  const redirect = DEFAULT_ROUTES[matchedKey] || "/customer/jobs";

  // Utility function to flatten nested routes
  const flattenRoutes = (routesArray) =>
    // Use flatMap to transform + flatten the array in one step
    routesArray.flatMap((route) =>
      // If the route has "collapse: true" and contains nested routes in "views" if true then show route.views else route
      route.collapse && route.views ? flattenRoutes(route.views) : [route],
    );

  useEffect(() => {
    const publicRoutes = [
      "/privacy-policy",
      "/user-reset-password",
      "/reset-password",
      "/review-quotation",
      "/payment/confirm",
      "/payment/result",
      "/404-not-found",
    ];

    //call to flattenRoutes function and store that routes array
    const flatRoutes = flattenRoutes(routes);

    const fullPaths = flatRoutes.map((r) => `${r.layout || ""}${r.path}`);

    //store current path
    const currentPath = location.pathname;
    //check route exist or not
    const routeExists = fullPaths.includes(currentPath);

    // If user is not authenticated
    if (
      !token &&
      !publicRoutes.some((path) => window.location.pathname.includes(path))
    ) {
      // If the requested path does not present in define routes then show 404 page
      if (!routeExists && location.pathname !== "/") {
        navigate("/404-not-found");
        return;
      }
      //else redirect to login
      navigate("/auth/login");
      return;
    }

    // If authenticated user navigates into /auth then redirect to dashboard
    if (token && location.pathname.startsWith("/auth")) {
      navigate(redirect);
      return;
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/customer/*" element={<AdminLayout />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/user-reset-password" element={<ForgetPassword />} />
      <Route path="/reset-password/:uuid" element={<ResetPassword />} />
      <Route path="/review-quotation/:uuid" element={<QuotationReview />} />
      <Route path="/payment/confirm" element={<PaymentConfirmScreen />} />
      <Route path="/payment/result" element={<PaymentStatus />} />
      <Route path="/404-not-found" element={<NotFound404 />} />
      <Route
        path="/"
        element={<Navigate to={token ? redirect : "/auth/*"} replace />}
      />
      <Route path="*" element={<NotFound404 />} />
    </Routes>
  );
}

export default App;